<div class="download">
    <div class="download__box">
        <h2 class="download__title">
            Join Us & Experience the Future of Multi-Service Apps
        </h2>

        <p class="download__subtitle">
            Join Us & Experience the Future of Multi-Service Apps
        </p>

        <a href="https://play.google.com/store/apps/details?id=com.app.whiterobe"
           target="_blank"
           class="download__btn">
            <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Google Play">
        </a>
    </div>
</div>